<template>
    <section>
        <VideoPoup :videoData="videoData" />
        <div class="row">
            <div class="col-md-3 col-sm-12 cus-sidebar">
                <Sidebar />
            </div>
            <div v-if="isLoading" class="loader">
                <div class="wave-container">
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                </div>
                <p>Loading...</p>
            </div>
            <div v-if="!isLoading" class="col-md-9 col-sm-12 right-colm">
                <div class="material-box bg-white new-material">

                    <div class="row content-row ">
                        <div class="contentbox w-100" v-for="(material, index) in materials" :key="index">
                            <div class="box-header text-center">
                                <h4>Module {{ material.ModuleNumber }} - {{ material.ModuleName }}</h4><br>
                            </div>
                            <div class="box-detail">
                                <div class="table-responsive tbl-wrap">
                                    <table class="table table-bordered table-striped materialsTbl materialsTbl-1">
                                        <thead>
                                            <tr>
                                                <th width="165px" class="wt">Weekly Topics</th>
                                                <th width="256" class="dc">Documents</th>
                                                <th width="256" class="vd">Videos</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-for="(week) in material.weeks">
                                                <tr class="headingtr" :key="week.WeekNumber">
                                                    <td colspan="3">
                                                        {{ week.WeekNumber }} - {{ week.WeekName }}
                                                    </td>
                                                </tr>
                                                <tr :key="week.WeekName">
                                                    <td></td>
                                                    <td class="documenttd">
                                                        <table width="100%" class="inner-table">
                                                            <tbody>
                                                                <template v-if="week.documents != undefined">
                                                                    <tr v-for="(doc, i) in week.documents" :key="i">
                                                                        <td class="documenttd">
                                                                            <a href="javascript:void(0);" class="pointer"
                                                                                :id="`popover-target${i}${doc.DocID}`">
                                                                                {{ (doc.DocName != undefined ? doc.DocName :
                                                                                    "")
                                                                                }}
                                                                            </a>
                                                                            <b-popover
                                                                                :target="`popover-target${i}${doc.DocID}`"
                                                                                triggers="focus" placement="right">
                                                                                <div class="btn-group" role="group">
                                                                                    <a :href="`${(host == '202.141.226.195') ? 'http://202.141.226.195:8001/storage/documents/8069578_1703609074.pdf' : $server_url+'storage/documents/'+doc.DocLocation}`"
                                                                                        type="button" target="_blank" class="btn yellow-btn">
                                                                                        <span class="glyphicon glyphicon-eye-open"></span>
                                                                                        View
                                                                                    </a>

                                                                                    <a @click.prevent="downloadFile(doc.DocLocation, doc.DocName)"
                                                                                        class="btn blue-btn">
                                                                                        <span
                                                                                            class="glyphicon glyphicon-cloud-download"></span>
                                                                                        Download
                                                                                    </a>
                                                                                </div>
                                                                            </b-popover>
                                                                        </td>
                                                                    </tr>
                                                                </template>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                    <td class="videotd">
                                                        <table width="100%" class="inner-table">
                                                            <tbody>
                                                                <template v-if="week.videos != undefined">
                                                                    <tr v-for="(video, j) in week.videos" :key="j">
                                                                        <td class="videotd">
                                                                            <div class="videomodal pointer"
                                                                                @click="videopoup(video.Link)">
                                                                                {{ video.VideoName }}</div>
                                                                        </td>
                                                                    </tr>
                                                                </template>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                    </div><!-- end content-row ---->

                </div>
            </div>
        </div>
    </section>
</template>

<script>
import userAPI from '../userApi';
import Sidebar from './components/Sidebar.vue';
import VideoPoup from './components/VideoPoup.vue';

export default {
    name: "materials",
    components: {
        Sidebar,
        VideoPoup
    },
    data() {
        const host = window.location.hostname;
        const port = window.location.port;
        return {
            isLoading: false,
            materials: {
                videos: {},
                documents: {}
            },
            host,
            port,
            videoData: {
                videoSrc: ""
            }

        }
    },
    methods: {
        downloadFile(location, name) {
            try {
                userAPI.downloadPdf({ path: window.location.hostname == '202.141.226.195' ? '8069578_1703609074.pdf' : location }, res => {

                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', name+".pdf"); // Set the desired file name and extension
                    link.style.display = 'none';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                });

            } catch (error) {
                console.error('Error downloading file:', error);
            }
        },
        videopoup(href) {
            this.videoData.videoSrc = this.videoSrc = 'https://player.vimeo.com/video/' + href;
            this.$bvModal.show("videoModel");
        },
        materialUserDashboard() {
            this.isLoading = true;
            userAPI.materialUserDashboard(res => {
                this.materials = res.data.data
                this.isLoading = false;

            }, err => {
                console.log(err);
                this.isLoading = false;

            })
        }
    },
    mounted() {
        this.materialUserDashboard();
    }


}


</script>

<style>
@media (max-width: 992px) {
    .contentbox .box-detail {
        margin-left: 0;
    }
}
</style>